import { FC } from 'react';
import SportsbookSeoLobbyFooter from '../../sportsbook-seo/sportsbook-seo-lobby-footer';

const EXPLORE_PAGE_SEO_CONTENT_PART1 = `SPORTSBOOK_EXPLORE_PAGE_SEO_CONTENT_PART1`;
const EXPLORE_PAGE_SEO_CONTENT_PART2 = `SPORTSBOOK_EXPLORE_PAGE_SEO_CONTENT_PART2`;

const SportsbookExploreSeoContainer: FC = () => {
	return (
		<SportsbookSeoLobbyFooter
			partOneTextKey={EXPLORE_PAGE_SEO_CONTENT_PART1}
			partTwoTextKey={EXPLORE_PAGE_SEO_CONTENT_PART2}
		/>
	);
};

export default SportsbookExploreSeoContainer;
